module.exports = __webpack_public_path__ + "static/media/100-10-1-welcome1.2b35bd5a.svg";